import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, Event, ActivatedRoute } from '@angular/router';
import { CommonService } from './provide/common.service';
import { AuthService } from './provide/auth.service';

declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'exobe-web';
  currUrl: any;
  view: boolean = true;
  isChatbotOpen: boolean = false;
  isDocumentOnly: boolean = false;
  isPdfViewing: boolean = false;
  shouldHideFooter: boolean = false;

  constructor(
    public commonService: CommonService, 
    public routes: Router, 
    public authService: AuthService,
    private renderer: Renderer2
  ) {
    localStorage.getItem('userFirstVisit') ? '' : this.openPopupModal();
    routes.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currUrl = event.url.split('/')[1];
        
        // Check if this is the login or signup page
        this.shouldHideFooter = event.url === '/login' || 
                               event.url.startsWith('/login?') ||
                               event.url === '/login-customer' ||
                               event.url === '/login-retailer' ||
                               event.url === '/login-service-provider' ||
                               event.url.includes('/signup');
        
        // Check if this is a document-only route
        this.isDocumentOnly = event.url.includes('-document');
        
        // Check if we're viewing a PDF (routes containing about, privacy, terms)
        this.isPdfViewing = event.url.includes('about') || 
                           event.url.includes('privacy') || 
                           event.url.includes('terms');
        
        // Add or remove document-only class on body
        if (this.isDocumentOnly) {
          this.renderer.addClass(document.body, 'document-only');
        } else {
          this.renderer.removeClass(document.body, 'document-only');
        }
        
        // Add or remove pdf-viewing class on body
        if (this.isPdfViewing) {
          this.renderer.addClass(document.body, 'pdf-viewing');
        } else {
          this.renderer.removeClass(document.body, 'pdf-viewing');
        }
        
        if (this.currUrl == 'user-not-approved') {
          this.view = false;
        } else {
          this.view = true;
        }
      }
    });

    // Listen for PDF viewer events
    this.commonService.pdfViewingState.subscribe((isViewing: boolean) => {
      this.isPdfViewing = isViewing;
      if (isViewing) {
        this.renderer.addClass(document.body, 'pdf-viewing');
      } else {
        this.renderer.removeClass(document.body, 'pdf-viewing');
      }
    });
  }

  ngOnInit(): void {
    // No ned to disable scrolling
    // Check initial route for login or signup page
    const currentUrl = this.routes.url;
    this.shouldHideFooter = currentUrl === '/login' || 
                            currentUrl.startsWith('/login?') ||
                            currentUrl === '/login-customer' ||
                            currentUrl === '/login-retailer' ||
                            currentUrl === '/login-service-provider' ||
                            currentUrl.includes('/signup');
  }

  toggleChatbot(): void {
    this.isChatbotOpen = !this.isChatbotOpen;
  }

  handleUnload(event: Event): void {}

  openPopupModal() {
    setTimeout(() => {
      $("#exampleModal").modal({backdrop: 'static', keyboard: false}, "show");
    }, 2000);
  }

  navigateTo(userType: string) {
    // Force close the modal immediately - multiple methods to ensure it closes
    const modal = $("#exampleModal");
    
    // Method 1: Use Bootstrap's modal hide
    if (modal.length && modal.data('bs.modal')) {
      modal.modal('hide');
    }
    
    // Method 2: Force remove all modal-related classes and styles
    modal.removeClass('show fade in');
    modal.css({
      'display': 'none',
      'padding-right': ''
    });
    modal.attr('aria-hidden', 'true');
    modal.attr('aria-modal', 'false');
    
    // Method 3: Remove all backdrop elements (there might be multiple)
    $('.modal-backdrop').remove();
    
    // Method 4: Reset body styles completely
    $('body').removeClass('modal-open');
    $('body').css({
      'padding-right': '',
      'overflow': ''
    });
    
    // Store user type
    localStorage.setItem('userFirstVisit', "true");
    localStorage.setItem('userType', userType);
    
    // Logout and navigate
    this.authService.logout();
    
    if (userType == 'CUSTOMER') {
      this.commonService.userTypeSelectionUpdate.next(userType);
      this.routes.navigate(['/home']);
    } else if (userType == 'RETAILER') {
      this.commonService.userTypeSelectionUpdate.next(userType);
      this.routes.navigate(['/login']);
    } else {
      this.commonService.userTypeSelectionUpdate.next(userType);
      this.routes.navigate(['/login-service-provider']);
    }
  }
}